import type { Address } from 'fhir/r4';

import { findProp } from '../array';
import { CountryCode } from '../coding';

export const getCity = findProp<Address, 'city'>('city');

export const getPostalCode = findProp<Address, 'postalCode'>('postalCode');

export const getAddressLines = findProp<Address, 'line'>('line');

export const countryDisplayMapping: Record<CountryCode, string> = {
  [CountryCode.SouthAfrica]: 'South Africa',
  [CountryCode.Namibia]: 'Namibia',
};

const countryCodes = Object.values(CountryCode);

const isCountryCode = (code?: string): code is CountryCode =>
  countryCodes.includes(code as CountryCode);

export const getCountry = (address?: Address): CountryCode | undefined => {
  const country = address?.country;

  const isValid = isCountryCode(country);
  if (!isValid) {
    return undefined;
  }

  return country;
};

export const getFirstLine = (address: Address[] = []): string | undefined => {
  const lines = getAddressLines(address);

  return lines?.[0];
};
